import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save, ShieldAlert, User } from "lucide-react";

export default function Impostazioni() {
  const { user, loadSettings } = useAuth();
  const isSuper = user?.role === "super_admin";
  const [idle, setIdle] = useState("");
  const [nome, setNome] = useState("");

  useEffect(() => {
    api.get("/settings").then(({ data }) => { setIdle(data.idle_timeout_min); setNome(data.nome_piattaforma); });
  }, []);

  const save = async () => {
    try {
      await api.put("/settings", { idle_timeout_min: parseInt(idle) || 20, nome_piattaforma: nome });
      toast.success("Impostazioni salvate"); loadSettings();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  return (
    <div className="max-w-2xl space-y-6" data-testid="impostazioni-page">
      <div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Impostazioni</h1>
        <p className="text-sm text-muted-foreground">Configurazione della piattaforma. Le soglie "da versare" si impostano per singola sede in Punti Vendita.</p>
      </div>

      <div className="rounded-xl border border-border bg-card p-5">
        <div className="mb-4 flex items-center gap-2"><User className="h-5 w-5 text-primary" /><h3 className="font-display font-bold">Il tuo account</h3></div>
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div><span className="text-muted-foreground">Username</span><div className="font-medium">{user?.username}</div></div>
          <div><span className="text-muted-foreground">Ruolo</span><div className="font-medium uppercase text-primary">{(user?.role || "").replace("_", " ")}</div></div>
        </div>
      </div>

      <div className="rounded-xl border border-border bg-card p-5">
        <div className="mb-4 flex items-center gap-2"><ShieldAlert className="h-5 w-5 text-primary" /><h3 className="font-display font-bold">Piattaforma & Sessione</h3></div>
        {!isSuper && <div className="mb-4 rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-2 text-sm text-amber-400">Solo il Super Admin può modificare queste impostazioni.</div>}
        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <Label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-muted-foreground">Nome piattaforma</Label>
            <Input value={nome} onChange={(e) => setNome(e.target.value)} disabled={!isSuper} className="h-12" data-testid="settings-nome-input" />
          </div>
          <div>
            <Label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-muted-foreground">Logout automatico (minuti)</Label>
            <Input type="number" value={idle} onChange={(e) => setIdle(e.target.value)} disabled={!isSuper} className="h-12 tabular-nums" data-testid="settings-idle-input" />
          </div>
        </div>
        {isSuper && <Button className="mt-4 gap-2 font-bold" onClick={save} data-testid="settings-save-btn"><Save className="h-4 w-4" /> Salva impostazioni</Button>}
      </div>
    </div>
  );
}
